var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAgentNewChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 2.16421H3.95C2.8299 2.16421 2.26984 2.16421 1.84202 2.3822C1.46569 2.57395 1.15973 2.87991 0.967987 3.25623C0.75 3.68406 0.75 4.24411 0.75 5.36421V10.9642C0.75 12.0843 0.75 12.6444 0.967987 13.0722C1.15973 13.4485 1.46569 13.7545 1.84202 13.9462C2.26984 14.1642 2.82989 14.1642 3.95 14.1642H9.55C10.6701 14.1642 11.2302 14.1642 11.658 13.9462C12.0343 13.7545 12.3403 13.4485 12.532 13.0722C12.75 12.6444 12.75 12.0843 12.75 10.9642V8.16421M4.74998 10.1642H5.86634C6.19247 10.1642 6.35553 10.1642 6.50898 10.1274C6.64502 10.0947 6.77508 10.0408 6.89438 9.96773C7.02894 9.88528 7.14424 9.76998 7.37484 9.53938L13.75 3.16421C14.3023 2.61193 14.3023 1.7165 13.75 1.16421C13.1977 0.611929 12.3023 0.611929 11.75 1.16421L5.37482 7.53938C5.14422 7.76998 5.02892 7.88528 4.94646 8.01983C4.87336 8.13913 4.81948 8.26919 4.78682 8.40524C4.74998 8.55869 4.74998 8.72175 4.74998 9.04787V10.1642Z",
    stroke: "#667085",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgentNewChat);
export default __webpack_public_path__ + "static/media/agent-new-chat.d1dc424d07f894ff0f29b2b59fa56562.svg";
export { ForwardRef as ReactComponent };